// material-ui
import { Box, useMediaQuery } from '@mui/material';

// project import
import Search from './Search';
import Profile from './Profile';
import WhatsAppChat from './WhatsAppChat';
import MobileSection from './MobileSection';
import Logo from 'components/Logo/Logo';

// ==============================|| HEADER - CONTENT ||============================== //

const HeaderContent = () => {
    const matchesXs = useMediaQuery((theme) => theme.breakpoints.down('md'));

    return (
        <>
            {!matchesXs && <Search />}
            {matchesXs && <Logo />}

            {matchesXs && <Box sx={{ width: '100%', ml: 1 }} />}

            {<WhatsAppChat />}
            {!matchesXs && <Profile />}
            {matchesXs && <MobileSection />}
        </>
    );
};

export default HeaderContent;
